export default "__VITE_ASSET__b201e441__"